import styled from 'styled-components';

export const ArtWrapper = styled.div`
  margin-top: 16px;
  a {
    text-decoration: revert;
    color: revert;
  }
  a:visited {
    text-decoration: revert;
    color: revert;
  }
  @media (max-width: 720px) {
    padding: 0 1em;
  }
`;

export const ContentTitle = styled.h1`
  font-size: 18px;
  font-weight: ${(props) => (props.normal ? '400' : '600')};
  color: hsl(0deg 0% 0% / 85%);

  & img {
    max-width: 100%;
    max-height: 100%;
    height: auto;
    width: auto;
  }
  & strong {
    color: rgba(62, 62, 62, 0.87);
  }
  & iframe {
    width: 100%;
  }
  & ul {
    list-style: none;
  }
  & p {
    padding: 8px 0;
  }
`;

export const ContentBody = styled.section`
  font-size: ${(props) => (props.normal ? '16px' : '1.5em')};
  font-weight: ${(props) => (props.normal ? '400' : '500')};
  color: hsl(0deg 0% 0% / 87%);
  padding-bottom: 0.6em;
  padding-top: 0.6em;
  line-height: 1.5;

  & img {
    max-width: 100%;
    height: auto !important;
    width: auto;
  }

  table {
    width: 100% !important;
    td {
      min-width: 100px !important;
    }
  }

  a {
    color: -webkit-link;
    text-decoration: underline;
    word-wrap: break-word;
  }

  h2 {
    font-size: clamp(18px, 2vw, 20px);
  }
  & strong:not(a > strong) {
    color: hsl(0deg, 0%, 0%, 87%);
    padding-bottom: 8px;
    display: inline-block;
  }
  & iframe {
    width: 100%;
  }
  & ul {
    list-style: inherit;
    padding-left: 16px;

    li {
      @media (max-width: 720px) {
        word-wrap: break-word;
      }
    }
  }

  pre {
    white-space: normal;
  }

  & ol {
    list-style: inherit;
    padding-left: 16px;
  }
  & p {
    padding: 8px 0;

    @media (max-width: 720px) {
      word-wrap: break-word;
    }

    span {
      font-family: 'Montserrat' !important;

      @media (max-width: 720px) {
        word-wrap: break-word;
      }
    }
  }
  & u {
    @media (max-width: 720px) {
      word-break: break-all;
    }
  }
  .adsWrapper {
    background-color: #eee;
    margin: 10px 0;
    .adStrip {
      font-size: 14px;
      padding: 14px 0;
      opacity: 0.8;
      text-align: center;
      letter-spacing: 0.1px;
    }
  }
  .publisherTag {
    min-width: 300px;
    background: #eeeeee60;
    place-items: center;
    flex-direction: column;
    margin-bottom: 10px;
    display: flex;
  }
`;

export const SecretList = styled.ul`
  padding: 1em;

  & li {
    padding: 0.6em 0;
    color: hsl(0deg 0% 0% / 85%);
    display: flex;
    align-items: flex-start;

    & img {
      display: inline-block;
      margin: 4px 8px 0 0;
    }
  }
`;
export const AmazonCardContainer = styled.div`
  padding: 12px 0;
  a {
    color: unset !important;
    text-decoration: unset !important;
  }

  img {
    padding-top: 8px;
    object-fit: cover;
  }
  h3 {
    text-align: center;
    font-size: clamp(14px, 2vw, 16px);
  }
  .button {
    background: #63b0a8;
    color: #fff;
    padding: 0px 8px;
    width: fit-content;
    border-radius: 4px;
    margin: auto;
    margin-top: 12px;
    @media (min-width: 720px) {
      display: none;
    }
  }
  .desktop {
    .button {
      display: block;
      @media (max-width: 720px) {
        display: none;
      }
    }
    .content {
      @media (min-width: 720px) {
        flex-basis: 85%;
      }
    }
    @media (min-width: 720px) {
      display: flex;
      width: 100%;
      flex-flow: row-reverse;
      gap: 30px;
      align-items: center;
    }
  }
  .imageContainer {
    width: 75%;
    margin: 12px auto 0;
    overflow: hidden;
    max-height: 400px;
    @media (min-width: 720px) {
      margin: unset;
    }
  }
`;

export const AmazonCarousel = styled.div`
  margin: 12px 0 20px 12px;

  .flexContainer {
    display: flex;
    overflow: scroll;
    width: 100%;
    gap: 8px;
    &::-webkit-scrollbar {
      display: none;
    }

    .imageContainer {
      overflow: hidden;
      img {
        width: 100%;
        height: 124px;
        object-fit: contain;
      }
    }

    p {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      padding-top: 12px;
      font-size: 14px;
      color: hsl(0deg 0% 0% / 87%);
      font-weight: 500;
    }
    .productCard {
      min-width: 44%;
      overflow: hidden;
      &:last-child {
        margin-right: 12px;
      }
    }
    .button {
      background: #63b0a8;
      color: #fff;
      padding: 8px;
      width: fit-content;
      border-radius: 4px;
      margin: auto;
      margin-top: 24px;
    }
  }
`;
